export default [
  {
    path: "/perikanan",
    component: () => import("@/pages/perikanan/perikanan-list.vue"),
    meta: {
      requiredLevel: ["admin", "perikanan"],
    },
  },
  {
    path: "/perikanan/import",
    component: () => import("@/pages/perikanan/perikanan-import.vue"),
    meta: {
      requiredLevel: ["admin", "perikanan"],
    },
  },
];
